<template>
  <div class="discovery-stats-hints-item">
    <i
      class="discovery-stats-hints-item__icon material-icons verify-extend-membership__icon"
    >
      check_circle
    </i>
    <p>{{ description }}</p>

    <a
      v-if="link"
      :href="link"
      target="_blank"
      class="discovery-stats-hints-item__link"
    >
      {{ title }}

      <i class="material-icons">
        open_in_new
      </i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'DiscoveryStatsHintsItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.discovery-stats-hints-item {
  font-size: rem-calc(12px);
  display: flex;
  padding: $global-padding * 0.75 0;

  &__icon {
    font-size: rem-calc(16px);
    color: #0faa60;
  }

  p {
    margin-bottom: 0;
    padding: 0 $global-padding * 0.5;
  }

  &__link {
    color: #409eff;
    flex-shrink: 0;
    margin-left: auto;

    @include rtl() {
      margin-left: 0;
      margin-right: auto;
    }

    i {
      font-size: rem-calc(16px);
    }
  }
}
</style>
